import {
    validatePresentation as validatePresentationIndicator,
    validatePresentationByResearchCommittee as validatePresentationIndicatorByResearchCommittee,
    deletePresentation as deletePresentationIndicator
} from './api'

const validatePresentation = async({ commit }, payload) => {
    try {
        const response = await validatePresentationIndicator(payload)
            
        return response.data.data
    } catch(e) {
        console.error(e)
    }
}

const validatePresentationByResearchCommittee = async({ commit }, payload) => {
    try {
        const response = await validatePresentationIndicatorByResearchCommittee(payload)
            
        return response.data.data
    } catch(e) {
        console.error(e)
    }
}

const deletePresentation = async({ commit }, payload) => {
    try {
        const response = await deletePresentationIndicator(payload)
            
        return response.data.data
    } catch(e) {
        console.error(e)
    }
}

export default {
    validatePresentation,
    validatePresentationByResearchCommittee,
    deletePresentation,
}
